import instance, { BASE_URL } from "../../services/api";
import toast from "react-hot-toast";

const getErrorMessage = (error) =>
  error?.response?.data?.detail ||
  error?.response?.data?.message ||
  error?.response?.data?.non_field_errors?.[0] ||
  (typeof error?.response?.data === "object"
    ? Object.values(error.response.data)[0]?.[0] ||
    Object.values(error.response.data)[0]
    : null) ||
  error?.message ||
  "Something went wrong. Please try again.";

const ForgotPasswordViewController = () => {
  const forgotPassword = (reqData) => async (dispatch) => {
    dispatch({ type: "FORGOT_PASSWORD_LOADING", payload: true });
    try {
      const response = await instance.post(`${BASE_URL}forgot-password/`, reqData);
      dispatch({
        type: "ADD_FORGOT_PASSWORD_EMAIL_SUCCESS",
        payload: response.data,
      });
      dispatch({ type: "FORGOT_PASSWORD_LOADING", payload: false });
      toast.success("OTP sent to your email.");
      return response.data;
    } catch (error) {
      dispatch({ type: "FORGOT_PASSWORD_LOADING", payload: false });
      dispatch({ type: "ADD_FORGOT_PASSWORD_EMAIL_FAILURE", payload: { error } });
      toast.error(getErrorMessage(error));
      throw error;
    }
  };

  const resetOtpPassword = (reqData) => async (dispatch) => {
    dispatch({ type: "FORGOT_PASSWORD_LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}reset-password/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);

      dispatch({ type: "ADD_RESET_PASSWORD_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });

      // Clear any existing tokens so the user isn't automatically logged in
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user_id");
      localStorage.removeItem("user_type");

      return Promise.resolve(data); // ✅ return success
    } catch (error) {
      dispatch({ type: "FORGOT_PASSWORD_LOADING", payload: false });
      dispatch({ type: "ADD_RESET_PASSWORD_FAILURE", payload: { error } });
      toast.error(getErrorMessage(error));
      throw error;
    }
  };

  const resendOtp = (reqData) => async (dispatch) => {
    dispatch({ type: "FORGOT_PASSWORD_LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}resend-forgot-password-otp/`,
        reqData
      );
      dispatch({ type: "SEND_RESEND_OTP_SUCCESS", payload: response.data });
      dispatch({ type: "FORGOT_PASSWORD_LOADING", payload: false });
      toast.success("OTP resent successfully.");
      return response.data;
    } catch (error) {
      dispatch({ type: "FORGOT_PASSWORD_LOADING", payload: false });
      dispatch({ type: "SEND_RESEND_OTP_FAILURE", payload: { error } });
      toast.error(getErrorMessage(error));
      throw error;
    }
  };

  return { forgotPassword, resetOtpPassword, resendOtp };
};

export default ForgotPasswordViewController;
